export default {
  getBackupPlanList: {
    url: "/mock/backup/plan/list",
    method: "get",
    desc: "备份计划查询",
    topTips: true
  },
  getBackupRecordList: {
    url: "/mock/backup/record/list",
    method: "get",
    desc: "备份记录查询",
    topTips: true
  }
};
